import { combineReducers } from '@reduxjs/toolkit'
import navigateBackBarVisible from './navigateBackBarVisible'
import selectedKPI from './selectedKPI'
import segmentVisibility from './segmentVisibility'
import bubbleExportVisible from './bubbleExportVisible'

const audienceProfiler = combineReducers({
  navigateBackBarVisible,
  segmentVisibility,
  selectedKPI,
  bubbleExportVisible,
})

export type AudienceProfiler = ReturnType<typeof audienceProfiler>

export default audienceProfiler
